<template>
  <div class="app-page">
    <PageHeader />
    <div class="application-page-container">
      <section>
        <div class="btn-action-group">
          <router-link :to="{ path: `/master/permission/hrbp_detail/new` }">
            <a-button type="primary">
              <PlusOutlined />
              {{ $t('admin.Add New HRBP') }}
            </a-button>
          </router-link>
        </div>
        <a-input-search
          clss="input-search-panel"
          v-model:value="keyword"
          allow-clear
          placeholder="HRBP"
          :loading="loading"
          @search="onSearch"
        />
      </section>
      <section class="application-counter">
        <div class="counter-text">
          {{ $t('admin.Total') }}: {{ pagination.total }}
          {{ pagination.total > 1 ? $t('admin.HRBPs') : $t('admin.HRBP') }}
        </div>
        <div class="page-pagination">
          <a-pagination
            @change="fetchData"
            v-model:current="pagination.current"
            :total="pagination.total"
            v-model:pageSize="pagination.pageSize"
            :pageSizeOptions="pagination.pageSizeOptions"
            size="small"
            show-less-items
            show-size-changer
            show-quick-jumper
          />
        </div>
      </section>
      <a-table
        class="job-table"
        :rowKey="(record) => record.id"
        :columns="columns"
        :data-source="dataSource"
        @change="onChange"
        :pagination="false"
      >
        <template v-slot:emptyText>
          <Empty />
        </template>
        <template v-slot:headerCell="{ title }">
          {{ $t('admin.' + title) }}
        </template>
        <template v-slot:bodyCell="{ record, column }">
          <template v-if="column.key === 'lion_id'">
            <span
              :class="{ highlight: record.lion_id.trim() == keyword.trim() }"
            >
              {{ record.lion_id }}
            </span>
          </template>
          <template v-if="column.key === 'name'">
            <span :class="{ highlight: record.name.trim() == keyword.trim() }">
              {{ record.name }}
            </span>
          </template>
          <template v-if="column.key === 'action'">
            <router-link
              :to="{ path: `/master/permission/hrbp_detail/${record.id}` }"
            >
              <a-button block type="link">{{ $t('admin.Edit') }}</a-button>
            </router-link>
            <a-button type="link" block @click="disableAccount(record)">
              {{ $t('admin.Cancel Account') }}
            </a-button>
          </template>
        </template>
      </a-table>
      <div class="table-pagination">
        <div></div>
        <a-pagination
          @change="fetchData"
          v-model:current="pagination.current"
          :total="pagination.total"
          v-model:pageSize="pagination.pageSize"
          :pageSizeOptions="pagination.pageSizeOptions"
          size="small"
          show-less-items
          show-size-changer
          show-quick-jumper
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PlusOutlined } from '@ant-design/icons-vue'
import PageHeader from '../components/PageHeader.vue'
import { getHRBPPermissionList } from '@/api/admin'
import { message, Modal } from 'ant-design-vue'
import { disableManagerAccount } from '@/api/admin'
// import { FilterOutlined } from '@ant-design/icons-vue'
import Empty from '@/components/Empty'

export default {
  name: 'Hrbp',
  components: {
    PageHeader,
    PlusOutlined,
    Empty,
  },
  data() {
    return {
      loading: false,
      uploadDataUrl: '/api/RoleC/Import',
      keyword: '',
      filteredInfo: {},
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '30', '50'],
      },
      dataSource: [],
      renameVisible: false,
      fileTemplate: {},
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'Lion ID',
          key: 'lion_id',
          dataIndex: 'lion_id',
        },
        {
          title: 'Name',
          key: 'name',
          dataIndex: 'name',
        },
        {
          title: 'Action',
          key: 'action',
          width: 150,
        },
      ]
    },
    ...mapGetters({
      ability: 'acl/ability',
      Authorization: 'user/accessToken',
    }),
    canCancel() {
      const ability = this.ability.find(
        (item) => item.key === 'can_cancel_account'
      )
      return ability.value
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const params = {
        pageSize: this.pagination.pageSize || 10,
        pageNum: this.pagination.current || 1,
        keywords: this.keyword,
      }
      this.loading = true
      getHRBPPermissionList(params)
        .then((res) => {
          if (res.code === 200) {
            this.dataSource = res.data
            this.pagination.total = res.page.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    disableAccount(record) {
      let that = this
      Modal.confirm({
        title: this.$t('admin.Cancel Account'),
        okText: this.$t('admin.Yes'),
        cancelText: this.$t('admin.No'),
        closable: true,
        content: this.$t(
          'admin.Are you sure you want to cancel the current account?'
        ),
        onOk() {
          return disableManagerAccount(record.id)
            .then((res) => {
              if (res.code === 200) {
                record.is_block = true
                that.fetchData()
              } else {
                message.info(res.msg)
              }
            })
            .catch((res) => {
              message.warning(res.msg)
            })
        },
      })
    },
    onSearch() {
      this.pagination.current = 1
      return this.fetchData()
    },
    onChange() {
      return this.fetchData()
    },
  },
}
</script>

<style lang="less" scoped>
@import url('@/styles/params.less');

.application-page-container {
  margin: @app-conetent-margin;
  background-color: white;
  padding: 24px;
  section {
    display: flex;
    justify-content: space-between;
  }

  .input-search-panel {
    width: 285px;
  }

  .application-counter {
    padding: 24px 0;
    align-items: center;
    .counter-text {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
      span {
        margin-right: 12px;
      }
    }
  }
}
.btn-groups {
  .ant-btn {
    display: block;
  }
}
.table-pagination {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.form-field-title {
  font-size: 14px;
  font-family: Helvetica;
  color: #333333;
  line-height: 22px;
  margin: 8px 0;
}
:deep {
  .table-pagination,
  .page-pagination {
    .ant-pagination-item-active {
      a {
        color: white;
      }
      background-color: @primary-color;
    }
  }
}
span.highlight {
  color: @primary-color;
  font-weight: bold;
}
</style>
